import { noop } from 'lodash-es';
import * as actionTypes from '../constants/actionTypes';
import { getPendingAndLoadedScreenCounts } from '../selectors/screen';
import * as events from './events';
var isPlayerReady = false;
var EVENTS = [];
export default (function (origHandleEvent) {
    if (origHandleEvent === void 0) { origHandleEvent = noop; }
    return function (action, state, previousState) {
        function handleEvent(event) {
            EVENTS.push(event);
            origHandleEvent(event, EVENTS);
        }
        if (action.type === actionTypes.IMAGE_LOADED) {
            var noOfPendingImages = getPendingAndLoadedScreenCounts(state).noOfPendingImages;
            if (noOfPendingImages === 0 && !isPlayerReady) {
                isPlayerReady = true;
            }
        }
        if (state.replay.status !== 'RECORDING' &&
            action.type !== actionTypes.REPLAY_STOP_RECORDING) {
            return;
        }
        switch (action.type) {
            case actionTypes.REPLAY_START_RECORDING:
                EVENTS = [];
                handleEvent(events.startRecording(action, state));
                handleEvent(events.initialScreen(action, state));
                handleEvent(events.resize(action, state));
                break;
            case actionTypes.REPLAY_STOP_RECORDING:
                handleEvent(events.stopRecording(action, state));
                break;
            case actionTypes.MISS_CLICK:
                handleEvent(events.missedClick(action, state));
                break;
            case actionTypes.SHOW_SCREEN:
            case actionTypes.SHOW_HOVER_SCREEN: {
                var event_1 = events.screenTransition(action, state);
                handleEvent(event_1);
                if (event_1.outcome.screen === state.replay.goalScreenPk) {
                    handleEvent(events.goalScreen(action, state));
                }
                break;
            }
            case actionTypes.SHOW_OVERLAY:
            case actionTypes.SHOW_HOVER_OVERLAY: {
                var event_2 = events.overlayTransition(action, state);
                handleEvent(event_2);
                if (event_2.outcome.screen === state.replay.goalScreenPk) {
                    handleEvent(events.goalScreen(action, state));
                }
                break;
            }
            case actionTypes.HIDE_OVERLAY:
                handleEvent(events.removeOverlay(action, state));
                break;
            case actionTypes.LOCATION_CHANGED:
                handleEvent(events.navigation(action, state, previousState));
                break;
            case actionTypes.MOVE_MOUSE:
                handleEvent(events.moveMouse(action, state));
                break;
            case actionTypes.SCROLL: {
                handleEvent(events.userScroll(action, state));
                break;
            }
            case actionTypes.SCROLL_TO:
                handleEvent(events.autoScroll('screen', action, state));
                break;
            case actionTypes.SET_OVERLAY_SCROLL_POS:
                handleEvent(events.autoScroll('layer', action, state));
                break;
            case actionTypes.SCREEN_RESIZED:
                handleEvent(events.resize(action, state));
                break;
            default:
                break;
        }
    };
});
